import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-lg text-gray-600"
}
const _hoisted_2 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_3 = {
  key: 0,
  class: "py-14 text-center px-4 text-gray-500 text-lg space-y-4"
}

import { computed } from 'vue';
import { parseISO } from 'date-fns';
import { useRoute } from 'vue-router';
import { ChevronRight } from 'lucide-vue-next';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import { Button } from '@/components/ui/button';
import { useInventoryScope } from '@/composables/inventory/useInventoryScope';
import { useMedicineInventoryDetail } from '@/plugins/store/actions/queries/inventory';
import MovementsTable from '../MovementsTable.vue';
import LotsCard from './LotsCard.vue';
import PeriodFigures from './PeriodFigures.vue';
import { i18n } from '@/plugins/internationalization/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const route = useRoute();

const farmId = computed(() => Number(route.params.farmId));
const drugId = computed(() => Number(route.params.drugId));
const unitId = computed(() => Number(route.params.unitId));
const ledgerKey = computed(() => ({
    farmId: farmId.value,
    drugId: drugId.value,
    unitId: unitId.value,
}));

// The detail is scoped to the key's own farm by the route; only the period comes from the global picker.
const { scopeOfFarm } = useInventoryScope();
const scope = computed(() => scopeOfFarm(farmId.value));
const { data: detail, isError, refetch } = useMedicineInventoryDetail(scope, farmId, drugId, unitId);

const heading = computed(() => detail.value?.drug_name ?? '');
const stockStart = computed(() => (detail.value?.stock_start ? i18n.global.d(parseISO(detail.value.stock_start), 'short') : null));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(DashboardContentLayout, {
    class: "space-y-8",
    heading: heading.value,
    "has-period-picker": true,
    "has-pig-type-picker": false
  }, {
    "above-heading": _withCtx(() => [
      _createVNode(_component_router_link, {
        to: { name: 'HealthInventory' },
        class: "inline-flex items-center gap-x-0.5 text-sm text-gray-500 hover:underline"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('views.health.inventory.detail.breadcrumb')) + " ", 1),
          _createVNode(_unref(ChevronRight), {
            class: "size-3.5",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      })
    ]),
    subheading: _withCtx(() => [
      (_unref(detail))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(detail).farm_name), 1))
        : _createCommentVNode("", true),
      (stockStart.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('views.health.inventory.detail.stockStart', { date: stockStart.value })), 1))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "border-black border-opacity-10" }, null, -1)),
      (_unref(isError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.pigs.records.errors.couldNotLoadData')), 1),
            _createVNode(_unref(Button), {
              variant: "outline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(refetch)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('views.pigs.records.errors.retry')), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(detail))
              ? (_openBlock(), _createBlock(PeriodFigures, {
                  key: 0,
                  detail: _unref(detail)
                }, null, 8, ["detail"]))
              : _createCommentVNode("", true),
            (_unref(detail))
              ? (_openBlock(), _createBlock(LotsCard, {
                  key: 1,
                  lots: _unref(detail).lots,
                  "unit-name": _unref(detail).unit_name
                }, null, 8, ["lots", "unit-name"]))
              : _createCommentVNode("", true),
            _createVNode(MovementsTable, { "ledger-key": ledgerKey.value }, null, 8, ["ledger-key"])
          ], 64))
    ]),
    _: 1
  }, 8, ["heading"]))
}
}

})